import { numericConditionSegments } from "@utils/conditionOperators";

const displayedConditionName = (condition) => {
  return condition.user_attribute || condition.condition_name;
};

const groupConditionsOverview = (conditions) => {
  let groupOverviewText = "";
  let areGroupConditionsSaved = true;

  const conditionsNumber = conditions?.length;
  if (!conditionsNumber) return { groupOverviewText, areGroupConditionsSaved };

  conditions?.map((condition, condIndex) => {
    if (!condition.condition_name && !condition.user_attribute) return (areGroupConditionsSaved = false);

    groupOverviewText += displayedConditionName(condition);
    const numeric = numericConditionSegments(condition);
    if (numeric) {
      groupOverviewText += numeric.map(({ text }) => text).join("");
    } else {
      groupOverviewText += condition.type === "is" ? "=" : "!=";
      groupOverviewText += condition.condition_values?.join(",");
    }

    if (condIndex < conditionsNumber - 1) groupOverviewText += ` ${condition.operator?.toUpperCase()} `;
  });
  return { groupOverviewText, areGroupConditionsSaved };
};

export const getConditionsOverviewText = (conditions, hasGroups = true, hidden = false) => {
  if (hidden) return "Hidden";
  if (hasGroups) {
    let overviewText = "";
    let areAllConditionsSaved = true; // Some fields are instantiated by backend at Save
    const groupsNumber = conditions?.length;
    if (!groupsNumber) return overviewText;

    conditions.map((conditionsGroup, groupIndex) => {
      const { groupOverviewText, areGroupConditionsSaved } = groupConditionsOverview(conditionsGroup.group_conditions);
      if (!areGroupConditionsSaved) return (areAllConditionsSaved = false);

      if (groupsNumber > 1) overviewText += "(";
      overviewText += groupOverviewText;
      if (groupsNumber > 1) overviewText += ")";
      if (groupIndex < groupsNumber - 1) overviewText += ` ${conditionsGroup.group_operator?.toUpperCase()} `;
    });
    return areAllConditionsSaved ? overviewText : "Save the survey to see the overview";
  } else {
    const { groupOverviewText, areGroupConditionsSaved } = groupConditionsOverview(conditions);
    return areGroupConditionsSaved ? groupOverviewText : "Save the survey to see the overview";
  }
};

const groupConditionsSegments = (conditions) => {
  const segments = [];
  const total = conditions?.length ?? 0;
  if (!total) return { segments, saved: true };

  for (const [index, condition] of conditions.entries()) {
    if (!condition.condition_name && !condition.user_attribute) return { segments: [], saved: false };

    segments.push({ kind: "q", text: displayedConditionName(condition) });
    const numeric = numericConditionSegments(condition);
    if (numeric) {
      segments.push(...numeric);
    } else {
      segments.push({ kind: "plain", text: condition.type === "is" ? " is " : " is not " });
      segments.push({ kind: "v", text: condition.condition_values?.join(", ") ?? "" });
    }
    if (index < total - 1) segments.push({ kind: "plain", text: ` ${condition.operator ?? "and"} ` });
  }
  return { segments, saved: true };
};

export const getConditionsSegments = (conditions, hasGroups = true) => {
  if (!hasGroups) {
    const { segments, saved } = groupConditionsSegments(conditions);
    return saved ? segments : [];
  }

  const groups = conditions ?? [];
  const all = [];
  for (const [index, group] of groups.entries()) {
    const { segments, saved } = groupConditionsSegments(group.group_conditions);
    if (!saved) return [];
    if (groups.length > 1) all.push({ kind: "plain", text: "(" });
    all.push(...segments);
    if (groups.length > 1) all.push({ kind: "plain", text: ")" });
    if (index < groups.length - 1) all.push({ kind: "plain", text: ` ${group.group_operator ?? "and"} ` });
  }
  return all;
};
